module.exports = __webpack_public_path__ + "img/logo-company.be90f536.png";